import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3613f460 = () => interopDefault(import('../pages/answersAndIdeas.vue' /* webpackChunkName: "pages/answersAndIdeas" */))
const _9f0187b0 = () => interopDefault(import('../pages/calendar.vue' /* webpackChunkName: "pages/calendar" */))
const _b10dacb8 = () => interopDefault(import('../pages/contractors.vue' /* webpackChunkName: "pages/contractors" */))
const _49789885 = () => interopDefault(import('../pages/fullDigitalTategaki.vue' /* webpackChunkName: "pages/fullDigitalTategaki" */))
const _901ba0f6 = () => interopDefault(import('../pages/fullDigitalTeishutsuTategaki.vue' /* webpackChunkName: "pages/fullDigitalTeishutsuTategaki" */))
const _37038ce1 = () => interopDefault(import('../pages/fullDigitalTeishutsuYokogaki.vue' /* webpackChunkName: "pages/fullDigitalTeishutsuYokogaki" */))
const _6eec143e = () => interopDefault(import('../pages/fullDigitalYokogaki.vue' /* webpackChunkName: "pages/fullDigitalYokogaki" */))
const _510e45da = () => interopDefault(import('../pages/lab.vue' /* webpackChunkName: "pages/lab" */))
const _8a659a6c = () => interopDefault(import('../pages/learn.vue' /* webpackChunkName: "pages/learn" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _49c57cf4 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _2e8c8665 = () => interopDefault(import('../pages/monthlyCheck.vue' /* webpackChunkName: "pages/monthlyCheck" */))
const _1bd7a742 = () => interopDefault(import('../pages/notice.vue' /* webpackChunkName: "pages/notice" */))
const _470b8820 = () => interopDefault(import('../pages/plans.vue' /* webpackChunkName: "pages/plans" */))
const _55d0b6c4 = () => interopDefault(import('../pages/puchipo.vue' /* webpackChunkName: "pages/puchipo" */))
const _f9b26d54 = () => interopDefault(import('../pages/setting.vue' /* webpackChunkName: "pages/setting" */))
const _0ba0fdd4 = () => interopDefault(import('../pages/submitPreview.vue' /* webpackChunkName: "pages/submitPreview" */))
const _7cfdc1a4 = () => interopDefault(import('../pages/teishutsuPreview.vue' /* webpackChunkName: "pages/teishutsuPreview" */))
const _d1584e4a = () => interopDefault(import('../pages/top.vue' /* webpackChunkName: "pages/top" */))
const _7dea006e = () => interopDefault(import('../pages/unit.vue' /* webpackChunkName: "pages/unit" */))
const _170f157c = () => interopDefault(import('../pages/viewer.vue' /* webpackChunkName: "pages/viewer" */))
const _539d2d42 = () => interopDefault(import('../pages/report/learningDiagnosis.vue' /* webpackChunkName: "pages/report/learningDiagnosis" */))
const _7a410564 = () => interopDefault(import('../pages/report/monthlyTest.vue' /* webpackChunkName: "pages/report/monthlyTest" */))
const _6f1933a1 = () => interopDefault(import('../pages/samples/common-func-sample.vue' /* webpackChunkName: "pages/samples/common-func-sample" */))
const _4a703e8d = () => interopDefault(import('../pages/samples/errorHandling.vue' /* webpackChunkName: "pages/samples/errorHandling" */))
const _6637f9fe = () => interopDefault(import('../pages/samples/messageEventHandlerSample.vue' /* webpackChunkName: "pages/samples/messageEventHandlerSample" */))
const _0fe553fe = () => interopDefault(import('../pages/samples/messagePosterSample.vue' /* webpackChunkName: "pages/samples/messagePosterSample" */))
const _06e3ef47 = () => interopDefault(import('../pages/samples/sandbox.vue' /* webpackChunkName: "pages/samples/sandbox" */))
const _1ad14548 = () => interopDefault(import('../pages/samples/speechSample.vue' /* webpackChunkName: "pages/samples/speechSample" */))
const _1311d9cf = () => interopDefault(import('../pages/samples/timerSample.vue' /* webpackChunkName: "pages/samples/timerSample" */))
const _d72e6508 = () => interopDefault(import('../pages/samples/viewerContents.vue' /* webpackChunkName: "pages/samples/viewerContents" */))
const _53aa6710 = () => interopDefault(import('../pages/report/abilityTest/Acourse.vue' /* webpackChunkName: "pages/report/abilityTest/Acourse" */))
const _39b7de6a = () => interopDefault(import('../pages/report/abilityTest/Tcourse.vue' /* webpackChunkName: "pages/report/abilityTest/Tcourse" */))
const _6de579c0 = () => interopDefault(import('../pages/report/assignmentTest/Tcourse.vue' /* webpackChunkName: "pages/report/assignmentTest/Tcourse" */))
const _83d7e9b0 = () => interopDefault(import('../pages/report/abilityTest/determineSchool/schoolOfChoice.vue' /* webpackChunkName: "pages/report/abilityTest/determineSchool/schoolOfChoice" */))
const _6881d225 = () => interopDefault(import('../pages/report/abilityTest/diagnoseSchool/schoolOfChoice.vue' /* webpackChunkName: "pages/report/abilityTest/diagnoseSchool/schoolOfChoice" */))
const _39e1114b = () => interopDefault(import('../pages/report/abilityTest/fixationLevel/schoolOfChoice.vue' /* webpackChunkName: "pages/report/abilityTest/fixationLevel/schoolOfChoice" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _26725654 = () => interopDefault(import('../pages/report/abilityTest/determineSchoolRanking/_subjectCode.vue' /* webpackChunkName: "pages/report/abilityTest/determineSchoolRanking/_subjectCode" */))
const _3f4cd2c0 = () => interopDefault(import('../pages/report/abilityTest/determineSchoolSubject/_subjectCode.vue' /* webpackChunkName: "pages/report/abilityTest/determineSchoolSubject/_subjectCode" */))
const _4dbee3f9 = () => interopDefault(import('../pages/report/abilityTest/diagnoseSchoolRanking/_subjectCode.vue' /* webpackChunkName: "pages/report/abilityTest/diagnoseSchoolRanking/_subjectCode" */))
const _4151a5c3 = () => interopDefault(import('../pages/report/abilityTest/diagnoseSchoolSubject/_subjectCode.vue' /* webpackChunkName: "pages/report/abilityTest/diagnoseSchoolSubject/_subjectCode" */))
const _41e72c93 = () => interopDefault(import('../pages/report/abilityTest/fixationLevelRanking/_subjectCode.vue' /* webpackChunkName: "pages/report/abilityTest/fixationLevelRanking/_subjectCode" */))
const _3579ee5d = () => interopDefault(import('../pages/report/abilityTest/fixationLevelSubject/_subjectCode.vue' /* webpackChunkName: "pages/report/abilityTest/fixationLevelSubject/_subjectCode" */))
const _5686734e = () => interopDefault(import('../pages/report/abilityTest/_subjectCode.vue' /* webpackChunkName: "pages/report/abilityTest/_subjectCode" */))
const _c4cf23ce = () => interopDefault(import('../pages/report/assignmentTest/_subjectCode.vue' /* webpackChunkName: "pages/report/assignmentTest/_subjectCode" */))
const _62dd65a1 = () => interopDefault(import('../pages/report/monthlyTestRanking/_subjectCode.vue' /* webpackChunkName: "pages/report/monthlyTestRanking/_subjectCode" */))
const _5670276b = () => interopDefault(import('../pages/report/monthlyTestSubject/_subjectCode.vue' /* webpackChunkName: "pages/report/monthlyTestSubject/_subjectCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/sho_webapp/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/answersAndIdeas",
    component: _3613f460,
    name: "answersAndIdeas"
  }, {
    path: "/calendar",
    component: _9f0187b0,
    name: "calendar"
  }, {
    path: "/contractors",
    component: _b10dacb8,
    name: "contractors"
  }, {
    path: "/fullDigitalTategaki",
    component: _49789885,
    name: "fullDigitalTategaki"
  }, {
    path: "/fullDigitalTeishutsuTategaki",
    component: _901ba0f6,
    name: "fullDigitalTeishutsuTategaki"
  }, {
    path: "/fullDigitalTeishutsuYokogaki",
    component: _37038ce1,
    name: "fullDigitalTeishutsuYokogaki"
  }, {
    path: "/fullDigitalYokogaki",
    component: _6eec143e,
    name: "fullDigitalYokogaki"
  }, {
    path: "/lab",
    component: _510e45da,
    name: "lab"
  }, {
    path: "/learn",
    component: _8a659a6c,
    name: "learn"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/logout",
    component: _49c57cf4,
    name: "logout"
  }, {
    path: "/monthlyCheck",
    component: _2e8c8665,
    name: "monthlyCheck"
  }, {
    path: "/notice",
    component: _1bd7a742,
    name: "notice"
  }, {
    path: "/plans",
    component: _470b8820,
    name: "plans"
  }, {
    path: "/puchipo",
    component: _55d0b6c4,
    name: "puchipo"
  }, {
    path: "/setting",
    component: _f9b26d54,
    name: "setting"
  }, {
    path: "/submitPreview",
    component: _0ba0fdd4,
    name: "submitPreview"
  }, {
    path: "/teishutsuPreview",
    component: _7cfdc1a4,
    name: "teishutsuPreview"
  }, {
    path: "/top",
    component: _d1584e4a,
    name: "top"
  }, {
    path: "/unit",
    component: _7dea006e,
    name: "unit"
  }, {
    path: "/viewer",
    component: _170f157c,
    name: "viewer"
  }, {
    path: "/report/learningDiagnosis",
    component: _539d2d42,
    name: "report-learningDiagnosis"
  }, {
    path: "/report/monthlyTest",
    component: _7a410564,
    name: "report-monthlyTest"
  }, {
    path: "/samples/common-func-sample",
    component: _6f1933a1,
    name: "samples-common-func-sample"
  }, {
    path: "/samples/errorHandling",
    component: _4a703e8d,
    name: "samples-errorHandling"
  }, {
    path: "/samples/messageEventHandlerSample",
    component: _6637f9fe,
    name: "samples-messageEventHandlerSample"
  }, {
    path: "/samples/messagePosterSample",
    component: _0fe553fe,
    name: "samples-messagePosterSample"
  }, {
    path: "/samples/sandbox",
    component: _06e3ef47,
    name: "samples-sandbox"
  }, {
    path: "/samples/speechSample",
    component: _1ad14548,
    name: "samples-speechSample"
  }, {
    path: "/samples/timerSample",
    component: _1311d9cf,
    name: "samples-timerSample"
  }, {
    path: "/samples/viewerContents",
    component: _d72e6508,
    name: "samples-viewerContents"
  }, {
    path: "/report/abilityTest/Acourse",
    component: _53aa6710,
    name: "report-abilityTest-Acourse"
  }, {
    path: "/report/abilityTest/Tcourse",
    component: _39b7de6a,
    name: "report-abilityTest-Tcourse"
  }, {
    path: "/report/assignmentTest/Tcourse",
    component: _6de579c0,
    name: "report-assignmentTest-Tcourse"
  }, {
    path: "/report/abilityTest/determineSchool/schoolOfChoice",
    component: _83d7e9b0,
    name: "report-abilityTest-determineSchool-schoolOfChoice"
  }, {
    path: "/report/abilityTest/diagnoseSchool/schoolOfChoice",
    component: _6881d225,
    name: "report-abilityTest-diagnoseSchool-schoolOfChoice"
  }, {
    path: "/report/abilityTest/fixationLevel/schoolOfChoice",
    component: _39e1114b,
    name: "report-abilityTest-fixationLevel-schoolOfChoice"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/report/abilityTest/determineSchoolRanking/:subjectCode?",
    component: _26725654,
    name: "report-abilityTest-determineSchoolRanking-subjectCode"
  }, {
    path: "/report/abilityTest/determineSchoolSubject/:subjectCode?",
    component: _3f4cd2c0,
    name: "report-abilityTest-determineSchoolSubject-subjectCode"
  }, {
    path: "/report/abilityTest/diagnoseSchoolRanking/:subjectCode?",
    component: _4dbee3f9,
    name: "report-abilityTest-diagnoseSchoolRanking-subjectCode"
  }, {
    path: "/report/abilityTest/diagnoseSchoolSubject/:subjectCode?",
    component: _4151a5c3,
    name: "report-abilityTest-diagnoseSchoolSubject-subjectCode"
  }, {
    path: "/report/abilityTest/fixationLevelRanking/:subjectCode?",
    component: _41e72c93,
    name: "report-abilityTest-fixationLevelRanking-subjectCode"
  }, {
    path: "/report/abilityTest/fixationLevelSubject/:subjectCode?",
    component: _3579ee5d,
    name: "report-abilityTest-fixationLevelSubject-subjectCode"
  }, {
    path: "/report/abilityTest/:subjectCode?",
    component: _5686734e,
    name: "report-abilityTest-subjectCode"
  }, {
    path: "/report/assignmentTest/:subjectCode?",
    component: _c4cf23ce,
    name: "report-assignmentTest-subjectCode"
  }, {
    path: "/report/monthlyTestRanking/:subjectCode?",
    component: _62dd65a1,
    name: "report-monthlyTestRanking-subjectCode"
  }, {
    path: "/report/monthlyTestSubject/:subjectCode?",
    component: _5670276b,
    name: "report-monthlyTestSubject-subjectCode"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
